import DiscussionListState from 'flarum/forum/states/DiscussionListState';
/**
 * Paginated list of blog articles, newest first.
 */
export default class BlogListState extends DiscussionListState {
  requestParams() {
    const filter = {
      blog: 'true'
    };
    if (this.params.category) filter.tag = this.params.category;
    if (this.params.language) filter.language = this.params.language;
    return {
      // Explicit includes replace the endpoint defaults, so everything the
      // overview items render must be listed here.
      include: ['user', 'tags', 'tags.parent', 'blogMeta'],
      filter,
      sort: '-createdAt'
    };
  }
}
flarum.reg.add('fof-blog', 'forum/states/BlogListState', BlogListState);